export default __webpack_public_path__ + "static/Mark-5.light-e6d700ef1f3cf251360d35253dd43182.jpg";